<template>
  <svg
    id="minit"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 310.2 122"
    style="enable-background:new 0 0 310.2 122;"
    xml:space="preserve"
  >
    <path
      class="st0"
      d="M217.4,108.4L217.4,108.4c-4.7,0-8.5-3.8-8.5-8.5V23.4c0-4.7,3.8-8.5,8.5-8.5h0c4.7,0,8.5,3.8,8.5,8.5v76.5
	C225.9,104.6,222.1,108.4,217.4,108.4z"
    />
    <path
      class="st0"
      d="M121.1,108.4L121.1,108.4c-4.7,0-8.5-3.8-8.5-8.5V23.4c0-4.7,3.8-8.5,8.5-8.5h0c4.7,0,8.5,3.8,8.5,8.5v76.5
	C129.6,104.6,125.8,108.4,121.1,108.4z"
    />
    <path
      class="st0"
      d="M285.5,40.4h-22.7c-3.1,0-5.7-2.5-5.7-5.7V23.4c0-4.7-3.8-8.5-8.5-8.5h0c-4.7,0-8.5,3.8-8.5,8.5v42.5v5.7v11.3
	c0,14.1,11.4,25.5,25.5,25.5h0H277h8.5c4.7,0,8.5-3.8,8.5-8.5s-3.8-8.5-8.5-8.5H277h-11.3h0c-4.7,0-8.5-3.8-8.5-8.5V71.5v-5.7V63
	c0-3.1,2.5-5.7,5.7-5.7h22.7c4.7,0,8.5-3.8,8.5-8.5S290.2,40.4,285.5,40.4z"
    />
    <path
      class="st0"
      d="M72.9,14.8c-14.1,0-25.5,11.4-25.5,25.5v28.3v2.8v17v11.3c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5V88.5v-17v-2.8
	V40.4c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v28.3v2.8v17v11.3c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5V88.5v-17v-2.8V40.4
	C98.4,26.3,87,14.8,72.9,14.8z"
    />
    <path
      class="st0"
      d="M169.3,14.8c-14.1,0-25.5,11.4-25.5,25.5v28.3v2.8v17v11.3c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5V88.5v-17
	v-2.8V40.4c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v28.3v2.8v17v11.3c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5V88.5v-17v-2.8V40.4
	C194.8,26.3,183.3,14.8,169.3,14.8z"
    />
    <path
      class="st0"
      d="M38.9,14.8c-14.1,0-25.5,11.4-25.5,25.5v28.3v2.8v17v11.3c0,4.7,3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5V88.5v-17v-2.8
	V40.4c0-4.7,3.8-8.5,8.5-8.5c1.4,0,2.6,0.3,3.8,0.9C44.1,27,47.1,22,51.1,18C47.5,16,43.3,14.8,38.9,14.8z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'Minit',
    replace: true,
    data () {
      return {}
    }
  }
</script>
